const getCatalyticsApiUrl = () => {
  if (process.env.REACT_APP_BUILD_ENV === 'development') {
    return 'https://rwemser6ij.execute-api.us-east-2.amazonaws.com/staging/api/v1/';
  }
  return 'https://api.catalytics.io/api/v1/';
};

export default getCatalyticsApiUrl;
